import React from 'react';
import TechnologyCard from './TechnologyCard';
import { techCategories } from '../data/techCategories';

const Technologies = () => {
  return (
    <section id="technologies" className="py-20 px-4 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Technology Stack
          </h2>
          <div className="w-20 h-1 bg-cyan-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Leveraging cutting-edge technologies and frameworks to build robust, scalable, and future-ready solutions
          </p>
        </div>

        {/* Technologies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {techCategories.map((category) => (
            <TechnologyCard
              key={category.category}
              category={category.category}
              icon={category.icon}
              color={category.color}
              technologies={category.technologies}
            />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            Don&apos;t see the technology you need? We&apos;re constantly evolving and adopting new tools.
          </p>
          <a
            href="#contact"
            className="inline-block bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Let&apos;s Discuss Your Tech Stack
          </a>
        </div>
      </div>
    </section>
  );
};

export default Technologies;
